"use client"

import React, { useState } from "react"
import { NotificationItemTemplate } from "./NotificationItemTemplate"
import { FragmentType, graphql, useFragment } from "@/gql"
import { NotificationActor } from "./NotificationActor"
import { Text } from "@/elements"
import { useRouter } from "next-nprogress-bar"
import { UserNotificationFeedItem } from "@/gql/graphql"

const CreativeWorkProjectLikeFragment = graphql(`
  fragment SubmittedJobInvitationAccepted on StreamNotificationFeedAggregatedActivity {
    id
    isSeen
    activities {
      id
      time
      target {
        ... on JobPosting {
          id
          title
        }
      }
      foreignObject {
        __typename
        ... on JobInvitation {
          id
          application {
            id
          }
        }
      }
      actor {
        id
        name
        ...NotificationActor
      }
    }
  }
`)

interface Props {
  onActorClick: (e: React.MouseEvent<any, MouseEvent>) => void
  item: FragmentType<typeof CreativeWorkProjectLikeFragment>
  onClick: (type: UserNotificationFeedItem) => void
}

export const SubmittedJobInvitationAccepted: React.FC<Props> = props => {
  const item = useFragment(CreativeWorkProjectLikeFragment, props.item)
  const activities = item.activities?.[0]
  const { onActorClick, onClick } = props
  const router = useRouter()

  const target =
    activities?.target?.__typename === "ClientJobPosting" || activities?.target?.__typename === "CreativeJobPosting"
      ? activities?.target
      : null

  const foreignObject = activities?.foreignObject?.__typename === "JobInvitation" ? activities?.foreignObject : null
  const actor = activities?.actor
  const actorName = actor?.name

  const jobTitle = target?.title

  const [hasPrefetched, setHasPrefetched] = useState(false)
  const link = `/hire/${target?.id}=?tab=invites&applicationId=${foreignObject?.application?.id}`
  const handleClick = () => {
    if (target) {
      onClick(UserNotificationFeedItem.JobInvitationAccepted)
      router.push(link)
    }
  }

  return (
    <NotificationItemTemplate
      isSeen={item.isSeen}
      onClick={handleClick}
      onMouseEnter={() => {
        if (hasPrefetched) return
        router.prefetch(link)
        setHasPrefetched(true)
      }}
      LeftComponent={actor && <NotificationActor actor={actor} onActorClick={onActorClick} />}
      TextContent={
        <Text element="span">
          <Text element="span" onClick={onActorClick} className="!font-medium">
            {actorName ?? "Member"}
          </Text>{" "}
          accepted your invitation to
          {jobTitle && (
            <Text element="span" className="!font-medium">
              {" "}
              {jobTitle}
            </Text>
          )}
          .
        </Text>
      }
      time={activities?.time}
    />
  )
}
